module.exports = __webpack_public_path__ + "img/avatar4.9a0a326f.png";